"use client";

import { c as _c } from "react/compiler-runtime";
import { useDisclosure } from "@dc/ui/components";
import { useHotkey } from "@tanstack/react-hotkeys";

// Activates the iOS virtual keyboard by focusing a temporary input.
// iOS Safari only shows the keyboard when .focus() is called synchronously
// within a user gesture — call this from onPointerDown on search triggers.
export function prefocusForKeyboard() {
  const tmp = document.createElement("input");
  tmp.style.position = "fixed";
  tmp.style.opacity = "0";
  tmp.style.fontSize = "16px"; // prevents iOS auto-zoom
  document.body.appendChild(tmp);
  tmp.focus();
  setTimeout(() => tmp.remove(), 1000);
}
export function useGlobalSearch() {
  const $ = _c(11);
  const {
    isOpen,
    onOpen,
    onClose,
    onOpenChange
  } = useDisclosure();
  let t0;
  if ($[0] !== isOpen || $[1] !== onClose || $[2] !== onOpen) {
    t0 = () => {
      if (isOpen) {
        onClose();
      } else {
        onOpen();
      }
    };
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = onOpen;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const toggleOpen = t0;
  let t1;
  if ($[4] !== toggleOpen) {
    t1 = e => {
      e.preventDefault();
      toggleOpen();
    };
    $[4] = toggleOpen;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useHotkey("Mod+K", t1);
  const shortcutLabel = typeof navigator === "undefined" ? "Ctrl+K" : /Mac|iPhone|iPad|iPod/.test(navigator.userAgent) ? "\u2318K" : "Ctrl+K";
  let t2;
  if ($[6] !== isOpen || $[7] !== onClose || $[8] !== onOpen || $[9] !== onOpenChange) {
    t2 = {
      isOpen,
      onOpen,
      onClose,
      onOpenChange,
      shortcutLabel
    };
    $[6] = isOpen;
    $[7] = onClose;
    $[8] = onOpen;
    $[9] = onOpenChange;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}